<template>
	<div class="radio-container" :class="{horizontal: direction === 'horizontal', vertical: direction === 'vertical', isDisabled: disabled}" @click="clickListener">
		<label ref="label-container" class="label-container" :for="id">{{ label }}</label>
		<div class="radio-button">
			<input ref="input" type="checkbox" :id="id" :checked="isChecked">
			<span class="checkmark"></span>
		</div>
	</div>
</template>

<script>
import {getRandomAlphanumericString} from "@/shared/helpers/strings";

export default {
	name: "AppRadioButton",
	emits: ["radio-toggle"],
	data() {
		return {
			isChecked: !!this.checked,
		}
	},
	props: {
		direction: {type: String, default: "vertical", validator(prop) {
			return ["horizontal", "vertical"].includes(prop)
		}},
		index: {type: Number, default: 0},
		label: {type: String, default: null},
		checked: {type: Boolean, default: false},
		disabled: {type: Boolean, default: false},
	},
	methods: {
		clickListener() {
			this.isChecked = !this.isChecked;
			this.$emit("radio-toggle", this.isChecked, this.index);
		},
		toggle(active = true) {
			this.isChecked = !!active;
		}
	},
	computed: {
		id() {
			return 'radio-' + getRandomAlphanumericString();
		},
	}
}
</script>

<style lang="scss" scoped>
.radio-container {
	display: flex;
	position: relative;
	cursor: pointer;
	pointer-events: all;

	& * {
		@include noSelect();
		pointer-events: none;
	}

	.label-container {
		color: var(--color-txt-1);
		font-size: 10px;
	}

	.radio-button {
		position: relative;
		margin-top: 5px;
		height: 30px;

		input {
			opacity: 0;
			cursor: pointer;
		}

		.checkmark {
			position: absolute;
			top: 0;
			left: 0;
			height: 27px;
			width: 27px;
			margin-left: 50%;
			border-radius: 50%;
			background: var(--color-bg);
			box-shadow: 0 1px 3px var(--color-box-shadow-3);
			transform: translateX(-50%);

			&:after {
				content: "";
				position: absolute;
				display: block;
				top: 6px;
				left: 6px;
				width: 15px;
				height: 15px;
				border-radius: 50%;
				background: var(--color-bg-primary-2);
				box-shadow: inset 0 1px 1px var(--color-box-shadow-3);
			}
		}

		input:checked ~ .checkmark {
			box-shadow: 0 0 2px var(--color-alpha-1);
		}

		input:checked ~ .checkmark:after {
			background-color: var(--color-secondary);
		}
	}


	&.horizontal {
		flex-direction: row;
		align-items: center;
		justify-content: center;
		margin-bottom: 10px;

		.label-container {
			order: 2;
		}

		.radio-button {
			margin-top: 0;
			margin-right: 16px;
		}
	}

	&.vertical {
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}

	&.isDisabled {
		pointer-events: none;
	}
}
</style>